// extracted by mini-css-extract-plugin
export default {"Root":"Section_Root__6c+2+","Title":"Section_Title__VKeB6","SubTitle":"Section_SubTitle__HLwD8","Button":"Section_Button__xvfCy"};